import { Popover } from '@chakra-ui/react';
import styled from 'styled-components';

interface TooltipContentProps {
  isJustification: boolean;
}
interface ContainerProps {
  color: string;
}
interface BadgeProps {
  value: string;
}

export const Container = styled.div<ContainerProps>`
  color: ${({ color }) => color || '#000000'};
  width: 100%;
  padding-left: 2px;
  height: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

export const Badge = styled.div<BadgeProps>`
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: ${({ value }) => value || '#ebebeb'};
`;

export const Tooltip = styled(Popover)`
  &-content {
    min-width: 100px;
    max-width: 250px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 3px 4px 3px #00000020;
  }
`;

export const CustomTooltip = styled(Popover)`
  &-content {
    min-width: 100px;
    max-width: 250px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
      rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
  }
`;

export const TooltipContent = styled.div<TooltipContentProps>`
  height: 100%;
  width: 100%;
  padding: 12px;
  display: grid;
  grid-template-rows: 2fr 2fr ${({ isJustification }) =>
      isJustification && '2fr'};

  h3 {
    font-size: 12px;
  }

  p {
    font-size: 11px;
    font-weight: normal;
  }
`;

export const Collaborator = styled.div`
  height: 100%;
  width: 100%;
  padding: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Block = styled.div`
  height: 100%;
  width: 100%;
  padding: 2px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const BlockContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Justification = styled.div`
  height: 100%;
  width: 100%;
  padding: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CountContent = styled.div`
  height: 50px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Divider = styled.div`
  margin: 8px 0;
  border: 0;
  height: 2px;
  background-image: linear-gradient(to right, transparent, #ccc, transparent);
`;
